import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import {useStyles} from "../MiscellanyOrder.style";
import clsx from "clsx";
import MiscellanyOrderRowProperties from "./MiscellanyOrderRowProperties";
import ShowDate from "../../../shared_components/Info/ShowDate/ShowDate";
import ShowText from '../../../shared_components/Info/ShowText/ShowText';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';
import ViewInvoiceButton from "../../../shared_components/Buttons/ViewInvoiceButton/ViewInvoiceButton";
import ShowOrderNumber from '../../../shared_components/Info/ShowOrderNumber/ShowOrderNumber';
import {useUserContext} from '../../../contexts/UserContext';
import AllowAccess from '../../../shared_components/Access/AllowAccess/AllowAccess';
import ExpandoMenu from '../../../ui_components/ExpandoMenu/ExpandoMenu';
import CommentsButton from '../../../shared_components/Buttons/CommentsButton/CommentsButton';
import Checkbox from '../../../ui_components/Checkbox/Checkbox';
import ShowPhoneNumber from '../../../shared_components/Info/ShowPhoneNumber/ShowPhoneNumber';
import ShowOrderStatus from '../../../shared_components/Info/ShowOrderStatus/ShowOrderStatus';
import UpdateDeliveryOrderStatusButton from '../../../shared_components/Buttons/UpdateDeliveryOrderStatusButton/UpdateDeliveryOrderStatusButton';
import DeliveryOrderType from '../../../model/DeliveryOrderType';
import ProductOrderStatus from '../../../entities/productOrder/ProductOrderStatus';
import ProductOrderTimelineButton from '../../../shared_components/Buttons/ProductOrderTimelineButton/ProductOrderTimelineButton';
import ShowArticleDescription from '../../../shared_components/Info/ShowArticleDescription/ShowArticleDescription';
import RemoveMiscellanyOrderButton from '../../../shared_components/Buttons/RemoveMiscellanyOrderButton/RemoveMiscellanyOrderButton';
import ShowMiscellanyOrderCategories from '../../../shared_components/Info/ShowMiscellanyOrderCategories/ShowMiscellanyOrderCategories';
import MiscellanyOrderDescriptionButton from '../../../shared_components/Buttons/MiscellanyOrderDescriptionButton/MiscellanyOrderDescriptionButton';
import ShowTotalToPayAmount from '../../../shared_components/Info/ShowTotalToPayAmount/ShowTotalToPayAmount';
import ClientOrderReceiptsButton from '../../../shared_components/Buttons/ClientOrderReceiptsButton/ClientOrderReceiptsButton';

const MiscellanyOrderRowMedium: React.FC<MiscellanyOrderRowProperties> = ({
                                                                          miscellanyOrder,
                                                                          selectedDeliveryOrderIds,
                                                                          onMiscellanyOrderSelect,
                                                                          onUpdate,
                                                                          filter,
                                                                          from,
                                                                          to
                                                                      }) => {


    const classes = useStyles();
    const i18n = useI18nContext();
    const userStore = useUserContext();

    const onInternalMiscellanyOrderSelect = () => {
        onMiscellanyOrderSelect(miscellanyOrder.id);
    }

    return (
        <div
            className={clsx(classes.article_info_container, userStore.isRootAgency() ? classes.article_info_container_grid_template_big : classes.article_info_container_grid_template_small)}>
            <div>
                <div className={classes.order_number_container}>
                    <Checkbox text={''} onChange={onInternalMiscellanyOrderSelect}
                              selected={selectedDeliveryOrderIds.findIndex(t => t === miscellanyOrder.id) >= 0}/>
                    <ShowOrderNumber orderNumber={miscellanyOrder.orderNumber}
                                     className={classes.order_number_text} textToHighlight={filter}/>
                </div>
                <ShowDate label={i18n.translate("CREATED")} timestamp={miscellanyOrder.createdAt}
                          className={classes.margin_top_4}/>
            </div>
            <div>
                <div className={classes.padding_right_5px}>
                    <ShowText text={miscellanyOrder.clientName} title={'Cliente'} textToHighlight={filter}/>
                    <div className={classes.client_receipt_btn}>
                        <ClientOrderReceiptsButton showText={false}
                            onlyIcon={true} from={from} to={to} clientId={miscellanyOrder.clientId} clientName={miscellanyOrder.clientName}/>
                    </div>
                    {miscellanyOrder.clientPhone &&
                        <ShowPhoneNumber value={miscellanyOrder.clientPhone} showFlag={false} textToHighlight={filter}/>}
                </div>
            </div>
            <div>
                <ShowMiscellanyOrderCategories categories={miscellanyOrder.miscellanyCategories}/>
            </div>
            <div className={classes.description_container}>
                <div className={classes.title}>Descripción:</div>
                <ShowArticleDescription
                    description={miscellanyOrder.description == null || miscellanyOrder.description === '' ? '-' : miscellanyOrder.description}/>
                <div className={classes.edit_description_link}>
                    <MiscellanyOrderDescriptionButton
                        orderId={miscellanyOrder.id}
                        orderNumber={miscellanyOrder.orderNumber}
                        orderDescription={miscellanyOrder.description}
                        showIcon={false}
                        isLinkText
                        onUpdate={onUpdate}/>
                </div>
            </div>
            <ShowTotalToPayAmount totalToPay={miscellanyOrder.totalToPay}></ShowTotalToPayAmount>
            <div>
                <ShowText text={miscellanyOrder.agencyName} title={'Agencia'}/>
                <ShowText text={miscellanyOrder.userName} title={'Vendedor'} className={classes.margin_top_8}/>
            </div>
            <div className={classes.status_container}>
                <ShowOrderStatus status={miscellanyOrder.status}/>
                {miscellanyOrder.status !== ProductOrderStatus.DELIVERED &&
                    miscellanyOrder.status !== ProductOrderStatus.CANCELED &&
                    <UpdateDeliveryOrderStatusButton onSave={onUpdate} productOrderId={miscellanyOrder.id} deliveryOrderType={DeliveryOrderType.MISCELLANY_ORDER}/>}
                {miscellanyOrder.status === ProductOrderStatus.DELIVERED &&
                    <ProductOrderTimelineButton
                        detailsLink
                        productOrderId={miscellanyOrder.id}
                    />}
            </div>
            
            <ExpandoMenu>
                <>
                    <ViewInvoiceButton
                        size={ButtonSize.SMALL}
                        productOrderId={miscellanyOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                    <ProductOrderTimelineButton
                        size={ButtonSize.SMALL}
                        productOrderId={miscellanyOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                    {/* <ObservationsButton
                        size={ButtonSize.SMALL}
                        deliveryOrderId={miscellanyOrder.id}
                        deliveryOrderNumber={miscellanyOrder.orderNumber}
                        deliveryOrderObservations={miscellanyOrder.observations}
                        showText
                        type={ButtonType.SECONDARY}
                    /> */}
                    <AllowAccess isRootAgency={true}>
                        <CommentsButton
                            size={ButtonSize.SMALL}
                            deliveryOrderId={miscellanyOrder.id}
                            deliveryOrderNumber={miscellanyOrder.orderNumber}
                            showText
                            type={ButtonType.SECONDARY}
                        />
                    </AllowAccess>
                    <RemoveMiscellanyOrderButton
                        size={ButtonSize.SMALL}
                        onSave={onUpdate}
                        miscellanyOrderId={miscellanyOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </>
            </ExpandoMenu>
        </div>
    )
}

export default MiscellanyOrderRowMedium;
